import PageTitle from '../Common/PageTitle'
import { Box, Container, Grid, TextField } from '@mui/material'
import { FC, Fragment, useRef, useState } from 'react'
import { useLocation } from 'react-router'
import { InputProps } from '../../types'
import { Apis } from '../../helpers'
import { Connect, mapStateToProps } from '../../Redux'
import { PropertyProps } from '../../types/properties'
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom'
import { EventsEmit } from '../../configs/events'

interface Props {
    selectedProperty?: PropertyProps
}
interface StateProps {
    inputs: InputProps[]
    adding: boolean
}
const NewContact: FC<Props> = ({
    selectedProperty
}) => {
    const location = useLocation()
    const { record } = location?.state || {}
    const fomrRef = useRef(null)

    const initialInputs: InputProps[] = [
        { label: 'Title', value: record?.title || '', field: 'title' },
        { label: 'Name', value: record?.name || '', field: 'name' },
        { label: 'Phone Number', value: record?.phoneNumber || '', field: 'phoneNumber' }
    ]
    const [state, setState] = useState<StateProps>({
        inputs: initialInputs,
        adding: false
    })
    const navigate = useNavigate()

    const { inputs, adding } = state
    //functions
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const obj: any = {}
        data.forEach((v, k) => obj[k] = v)
        setState({ ...state, adding: true })
        Apis({
            module: 'Properties',
            action: 'addUpdateDeleteContact',
            ...obj,
            subAction: record?._id ? 'update' : 'add',
            recordId: record?._id,
            propertId: selectedProperty?._id
        }).then(({ message, error }: any) => {
            setState({ ...state, adding: false })
            EventsEmit('app', {
                info: {
                    message,
                    status: error ? 'error' : 'success'
                },
            })
            if (!error)
                navigate(-1)
        }).catch(() => {
            setState({ ...state, adding: false })
        })

    };
    return (
        <Fragment>
            <PageTitle
                title={`${record?._id ? 'Update' : 'Add'} Contact`}
                backBtn
            />
            <Container component="main" maxWidth="sm" sx={{
                pt: 10,
                ml: 10
            }}>
                <Box component="form" ref={fomrRef} onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <Grid container spacing={3}>
                        {
                            inputs.map(({ label, value, field }) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    key={field}
                                >
                                    <TextField
                                        autoComplete="given-name"
                                        name={field}
                                        required
                                        fullWidth
                                        label={label}
                                        defaultValue={value}
                                        autoFocus={field === 'title'}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>
                    <LoadingButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2, textTransform: 'none' }}
                        loading={adding}
                    >
                        {`${record?._id ? 'Update' : 'Add'} Contact`}
                    </LoadingButton>
                </Box>
            </Container>
        </Fragment>
    )
}

export default Connect(mapStateToProps)(NewContact)
